// @flow

import * as React from "react";
import '../css/PricingCardET.css';
import PricingCardET from "../components/pricing-login-register/PricingCardTRUE";
import {URL_LOCAL, URL_PROD, URL_QA} from "../util/Constants";
import {AppBar, Box, Container, MenuItem, Select, Stack, Toolbar, Typography, IconButton} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faGlobe} from "@fortawesome/free-solid-svg-icons/faGlobe";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Flag from "react-world-flags";

const cards = [
    //"free",
    // "perMonth",
    "company"];

function PricingCardsPage () {
    const {t, i18n} = useTranslation();
    const history = useHistory();

    return (
        <Box className="page" >
            <AppBar
                color="transparent"
                sx={{ boxShadow: '0px 0px 0px 0px', backgroundColor: 'white' }}
            >
                <Toolbar>
                    <Box sx={{ flexGrow: 1 }}>
                        <a href={(window.location.host.includes("tool.trueffort") ? URL_PROD : window.location.host.includes("qa.trueffort") ? URL_QA : URL_LOCAL ) + 'login#/'}>
                            <img className="h-8 mt-0" src={"./assets/images/new_logo.png"} alt="TrueUEffort"/>
                        </a>
                    </Box>

                    <Typography>
                        {t("Dont_have_account?")} <a onClick={() => history.push("pricing")} href="#">{t("forms.go_signUp")}</a>
                    </Typography>
                </Toolbar>
            </AppBar>
            <Toolbar />

            <Box className="page-single" >
                <Stack direction='row' justifyContent='center' >
                    {cards.map((card) =>
                        <PricingCardET key={card} cardType={card}/>
                    )}
                </Stack>
            </Box>

            <Box
                component="footer"
                sx={{ py: 1, px: 2, mt: 'auto' }}
            >
                <Container maxWidth="sm" sx={{ textAlign: "center" }} >
                    <Select
                        size="small"
                        id="language-login-select"
                        value={i18n.language === "es" ? t("Spanish") : t("English")}
                        onChange={(e: any) => i18n.changeLanguage(e.target.value)}
                        renderValue={(value: any) => {
                            return (
                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <FontAwesomeIcon size="lg" icon={faGlobe} />
                                    {value}
                                    {/*<FontAwesomeIcon icon={faChevronDown} />*/}
                                </Box>
                            )
                        }}
                        sx={{ '.MuiOutlinedInput-notchedOutline': { border: 0 }, color: '#07074E' }}
                        IconComponent={KeyboardArrowDownIcon}
                    >
                        <MenuItem value="es"><Flag code={"mx"} height="16" />&nbsp;&nbsp;{t("Spanish")}</MenuItem>
                        <MenuItem value="en"><Flag code={"us"} height="16" />&nbsp;&nbsp;{t("English")}</MenuItem>
                    </Select>
                </Container>
            </Box>
        </Box>
    );
}

export default PricingCardsPage;
